module.exports = __webpack_public_path__ + "static/img/yunpic1.2e678f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yunpic1.jpg
// module id = aoC4
// module chunks = 0